export const templateObj = {
    layouts: [
        {
            box: {
                x: 7,
                y: 4,
                w: 2,
                h: 7,
                i: 'f2feef97-10af-4c3c-9a07-e045f74b1bbd',
                static: false,
                type: 'textBox',
            },
            style: {
                content: 'CREAT-IVE\nPORT-FOLIO',
                editorState: {
                    _immutable: {
                        allowUndo: true,
                        currentContent: {
                            entityMap: {},
                            blockMap: {
                                f9tvc: {
                                    key: 'f9tvc',
                                    type: 'unstyled',
                                    text: 'CREAT-IVE',
                                    characterList: [
                                        {
                                            style: ['BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                    ],
                                    depth: 0,
                                    data: {},
                                },
                                '2cfob': {
                                    key: '2cfob',
                                    type: 'unstyled',
                                    text: 'PORT-FOLIO',
                                    characterList: [
                                        {
                                            style: ['BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                    ],
                                    depth: 0,
                                    data: {},
                                },
                            },
                            selectionBefore: {
                                anchorKey: '2cfob',
                                anchorOffset: 4,
                                focusKey: '2cfob',
                                focusOffset: 4,
                                isBackward: false,
                                hasFocus: true,
                            },
                            selectionAfter: {
                                anchorKey: '2cfob',
                                anchorOffset: 5,
                                focusKey: '2cfob',
                                focusOffset: 5,
                                isBackward: false,
                                hasFocus: true,
                            },
                        },
                        decorator: null,
                        directionMap: {
                            f9tvc: 'LTR',
                            '2cfob': 'LTR',
                        },
                        forceSelection: false,
                        inCompositionMode: false,
                        inlineStyleOverride: null,
                        lastChangeType: 'insert-characters',
                        nativelyRenderedContent: null,
                        redoStack: [],
                        selection: {
                            anchorKey: '2cfob',
                            anchorOffset: 7,
                            focusKey: '2cfob',
                            focusOffset: 7,
                            isBackward: false,
                            hasFocus: false,
                        },
                        treeMap: {
                            f9tvc: [
                                {
                                    start: 0,
                                    end: 9,
                                    decoratorKey: null,
                                    leaves: [
                                        {
                                            start: 0,
                                            end: 9,
                                        },
                                    ],
                                },
                            ],
                            '2cfob': [
                                {
                                    start: 0,
                                    end: 10,
                                    decoratorKey: null,
                                    leaves: [
                                        {
                                            start: 0,
                                            end: 10,
                                        },
                                    ],
                                },
                            ],
                        },
                        undoStack: [
                            {
                                entityMap: {},
                                blockMap: {
                                    f9tvc: {
                                        key: 'f9tvc',
                                        type: 'unstyled',
                                        text: 'CREAT-IVE',
                                        characterList: [
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '2cfob': {
                                        key: '2cfob',
                                        type: 'unstyled',
                                        text: 'PORTFOLIO',
                                        characterList: [
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'f9tvc',
                                    anchorOffset: 5,
                                    focusKey: 'f9tvc',
                                    focusOffset: 5,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: 'f9tvc',
                                    anchorOffset: 6,
                                    focusKey: 'f9tvc',
                                    focusOffset: 6,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    f9tvc: {
                                        key: 'f9tvc',
                                        type: 'unstyled',
                                        text: 'CREATIVE',
                                        characterList: [
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '2cfob': {
                                        key: '2cfob',
                                        type: 'unstyled',
                                        text: 'PORTFOLIO',
                                        characterList: [
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR', 'TITLE'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'f9tvc',
                                    anchorOffset: 0,
                                    focusKey: '2cfob',
                                    focusOffset: 9,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'f9tvc',
                                    anchorOffset: 0,
                                    focusKey: '2cfob',
                                    focusOffset: 9,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    f9tvc: {
                                        key: 'f9tvc',
                                        type: 'unstyled',
                                        text: 'CREATIVE',
                                        characterList: [
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '2cfob': {
                                        key: '2cfob',
                                        type: 'unstyled',
                                        text: 'PORTFOLIO',
                                        characterList: [
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'f9tvc',
                                    anchorOffset: 0,
                                    focusKey: '2cfob',
                                    focusOffset: 9,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'f9tvc',
                                    anchorOffset: 0,
                                    focusKey: '2cfob',
                                    focusOffset: 9,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    f9tvc: {
                                        key: 'f9tvc',
                                        type: 'unstyled',
                                        text: 'CREATIVE',
                                        characterList: [
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '2cfob': {
                                        key: '2cfob',
                                        type: 'unstyled',
                                        text: 'PORTFOLIO',
                                        characterList: [
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'f9tvc',
                                    anchorOffset: 0,
                                    focusKey: '2cfob',
                                    focusOffset: 9,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'f9tvc',
                                    anchorOffset: 0,
                                    focusKey: '2cfob',
                                    focusOffset: 9,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    f9tvc: {
                                        key: 'f9tvc',
                                        type: 'unstyled',
                                        text: 'CREATIVE',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '2cfob': {
                                        key: '2cfob',
                                        type: 'unstyled',
                                        text: 'PORTFOLIO',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'f9tvc',
                                    anchorOffset: 0,
                                    focusKey: '2cfob',
                                    focusOffset: 9,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'f9tvc',
                                    anchorOffset: 0,
                                    focusKey: '2cfob',
                                    focusOffset: 9,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    f9tvc: {
                                        key: 'f9tvc',
                                        type: 'unstyled',
                                        text: 'CREATIVE',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '2cfob': {
                                        key: '2cfob',
                                        type: 'unstyled',
                                        text: 'PORTFOLIO',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '2cfob',
                                    anchorOffset: 0,
                                    focusKey: '2cfob',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: '2cfob',
                                    anchorOffset: 9,
                                    focusKey: '2cfob',
                                    focusOffset: 9,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    f9tvc: {
                                        key: 'f9tvc',
                                        type: 'unstyled',
                                        text: 'CREATIVE',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '2cfob': {
                                        key: '2cfob',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'f9tvc',
                                    anchorOffset: 8,
                                    focusKey: 'f9tvc',
                                    focusOffset: 8,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: '2cfob',
                                    anchorOffset: 0,
                                    focusKey: '2cfob',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    f9tvc: {
                                        key: 'f9tvc',
                                        type: 'unstyled',
                                        text: 'CREATIVE',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'f9tvc',
                                    anchorOffset: 0,
                                    focusKey: 'f9tvc',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: 'f9tvc',
                                    anchorOffset: 8,
                                    focusKey: 'f9tvc',
                                    focusOffset: 8,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    f9tvc: {
                                        key: 'f9tvc',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'f9tvc',
                                    anchorOffset: 0,
                                    focusKey: 'f9tvc',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'f9tvc',
                                    anchorOffset: 0,
                                    focusKey: 'f9tvc',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    f9tvc: {
                                        key: 'f9tvc',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'f9tvc',
                                    anchorOffset: 0,
                                    focusKey: 'f9tvc',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'f9tvc',
                                    anchorOffset: 0,
                                    focusKey: 'f9tvc',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                        ],
                    },
                },
                textColor: '#003747',
                textOpacity: 100,
                textAlign: 'left',
                fontSize: '6.5rem',
                lineHeight: '6.5rem',
                fontFamily: 'BROWN_SUGAR',
                isFocus: false,
            },
        },
        {
            box: {
                x: 9,
                y: 16,
                w: 2,
                h: 2,
                i: 'e1b00f23-8e34-4845-970c-77d3e3560b47',
                static: false,
                type: 'textBox',
            },
            style: {
                content: 'Artists\nRick Rothenberg\nPlanet Volumes',
                editorState: {
                    _immutable: {
                        allowUndo: true,
                        currentContent: {
                            entityMap: {},
                            blockMap: {
                                '182p5': {
                                    key: '182p5',
                                    type: 'unstyled',
                                    text: 'Artists',
                                    characterList: [
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING', 'BOLD'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING', 'BOLD'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING', 'BOLD'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING', 'BOLD'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING', 'BOLD'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING', 'BOLD'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING', 'BOLD'],
                                            entity: null,
                                        },
                                    ],
                                    depth: 0,
                                    data: {},
                                },
                                '3kn5l': {
                                    key: '3kn5l',
                                    type: 'unstyled',
                                    text: 'Rick Rothenberg',
                                    characterList: [
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                    ],
                                    depth: 0,
                                    data: {},
                                },
                                eqe3p: {
                                    key: 'eqe3p',
                                    type: 'unstyled',
                                    text: 'Planet Volumes',
                                    characterList: [
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                    ],
                                    depth: 0,
                                    data: {},
                                },
                            },
                            selectionBefore: {
                                anchorKey: '182p5',
                                anchorOffset: 0,
                                focusKey: '182p5',
                                focusOffset: 7,
                                isBackward: false,
                                hasFocus: true,
                            },
                            selectionAfter: {
                                anchorKey: '182p5',
                                anchorOffset: 0,
                                focusKey: '182p5',
                                focusOffset: 7,
                                isBackward: false,
                                hasFocus: true,
                            },
                        },
                        decorator: null,
                        directionMap: {
                            '182p5': 'LTR',
                            '3kn5l': 'LTR',
                            eqe3p: 'LTR',
                        },
                        forceSelection: false,
                        inCompositionMode: false,
                        inlineStyleOverride: null,
                        lastChangeType: 'change-inline-style',
                        nativelyRenderedContent: null,
                        redoStack: [],
                        selection: {
                            anchorKey: '182p5',
                            anchorOffset: 0,
                            focusKey: '182p5',
                            focusOffset: 0,
                            isBackward: false,
                            hasFocus: false,
                        },
                        treeMap: {
                            '182p5': [
                                {
                                    start: 0,
                                    end: 7,
                                    decoratorKey: null,
                                    leaves: [
                                        {
                                            start: 0,
                                            end: 7,
                                        },
                                    ],
                                },
                            ],
                            '3kn5l': [
                                {
                                    start: 0,
                                    end: 15,
                                    decoratorKey: null,
                                    leaves: [
                                        {
                                            start: 0,
                                            end: 15,
                                        },
                                    ],
                                },
                            ],
                            eqe3p: [
                                {
                                    start: 0,
                                    end: 14,
                                    decoratorKey: null,
                                    leaves: [
                                        {
                                            start: 0,
                                            end: 14,
                                        },
                                    ],
                                },
                            ],
                        },
                        undoStack: [
                            {
                                entityMap: {},
                                blockMap: {
                                    '182p5': {
                                        key: '182p5',
                                        type: 'unstyled',
                                        text: 'Artists',
                                        characterList: [
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '3kn5l': {
                                        key: '3kn5l',
                                        type: 'unstyled',
                                        text: 'Rick Rothenberg',
                                        characterList: [
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    eqe3p: {
                                        key: 'eqe3p',
                                        type: 'unstyled',
                                        text: 'Planet Volumes',
                                        characterList: [
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT', 'SUB_HEADING'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '182p5',
                                    anchorOffset: 0,
                                    focusKey: 'eqe3p',
                                    focusOffset: 14,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '182p5',
                                    anchorOffset: 0,
                                    focusKey: 'eqe3p',
                                    focusOffset: 14,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '182p5': {
                                        key: '182p5',
                                        type: 'unstyled',
                                        text: 'Artists',
                                        characterList: [
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '3kn5l': {
                                        key: '3kn5l',
                                        type: 'unstyled',
                                        text: 'Rick Rothenberg',
                                        characterList: [
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    eqe3p: {
                                        key: 'eqe3p',
                                        type: 'unstyled',
                                        text: 'Planet Volumes',
                                        characterList: [
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '182p5',
                                    anchorOffset: 0,
                                    focusKey: 'eqe3p',
                                    focusOffset: 14,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '182p5',
                                    anchorOffset: 0,
                                    focusKey: 'eqe3p',
                                    focusOffset: 14,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '182p5': {
                                        key: '182p5',
                                        type: 'unstyled',
                                        text: 'Artists',
                                        characterList: [
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '3kn5l': {
                                        key: '3kn5l',
                                        type: 'unstyled',
                                        text: 'Rick Rothenberg',
                                        characterList: [
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    eqe3p: {
                                        key: 'eqe3p',
                                        type: 'unstyled',
                                        text: 'Planet Volumes',
                                        characterList: [
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '182p5',
                                    anchorOffset: 0,
                                    focusKey: 'eqe3p',
                                    focusOffset: 14,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '182p5',
                                    anchorOffset: 0,
                                    focusKey: 'eqe3p',
                                    focusOffset: 14,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '182p5': {
                                        key: '182p5',
                                        type: 'unstyled',
                                        text: 'Artists',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '3kn5l': {
                                        key: '3kn5l',
                                        type: 'unstyled',
                                        text: 'Rick Rothenberg',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    eqe3p: {
                                        key: 'eqe3p',
                                        type: 'unstyled',
                                        text: 'Planet Volumes',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '182p5',
                                    anchorOffset: 0,
                                    focusKey: 'eqe3p',
                                    focusOffset: 14,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '182p5',
                                    anchorOffset: 0,
                                    focusKey: 'eqe3p',
                                    focusOffset: 14,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '182p5': {
                                        key: '182p5',
                                        type: 'unstyled',
                                        text: 'Artists',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '3kn5l': {
                                        key: '3kn5l',
                                        type: 'unstyled',
                                        text: 'Rick Rothenberg',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    eqe3p: {
                                        key: 'eqe3p',
                                        type: 'unstyled',
                                        text: 'Planet Volumes',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'eqe3p',
                                    anchorOffset: 4,
                                    focusKey: 'eqe3p',
                                    focusOffset: 4,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: 'eqe3p',
                                    anchorOffset: 14,
                                    focusKey: 'eqe3p',
                                    focusOffset: 14,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '182p5': {
                                        key: '182p5',
                                        type: 'unstyled',
                                        text: 'Artists',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '3kn5l': {
                                        key: '3kn5l',
                                        type: 'unstyled',
                                        text: 'Rick Rothenberg',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    eqe3p: {
                                        key: 'eqe3p',
                                        type: 'unstyled',
                                        text: 'Plan',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'eqe3p',
                                    anchorOffset: 5,
                                    focusKey: 'eqe3p',
                                    focusOffset: 5,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: 'eqe3p',
                                    anchorOffset: 4,
                                    focusKey: 'eqe3p',
                                    focusOffset: 4,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '182p5': {
                                        key: '182p5',
                                        type: 'unstyled',
                                        text: 'Artists',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '3kn5l': {
                                        key: '3kn5l',
                                        type: 'unstyled',
                                        text: 'Rick Rothenberg',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    eqe3p: {
                                        key: 'eqe3p',
                                        type: 'unstyled',
                                        text: 'Plant',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'eqe3p',
                                    anchorOffset: 0,
                                    focusKey: 'eqe3p',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: 'eqe3p',
                                    anchorOffset: 5,
                                    focusKey: 'eqe3p',
                                    focusOffset: 5,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '182p5': {
                                        key: '182p5',
                                        type: 'unstyled',
                                        text: 'Artists',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '3kn5l': {
                                        key: '3kn5l',
                                        type: 'unstyled',
                                        text: 'Rick Rothenberg',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    eqe3p: {
                                        key: 'eqe3p',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '3kn5l',
                                    anchorOffset: 15,
                                    focusKey: '3kn5l',
                                    focusOffset: 15,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: 'eqe3p',
                                    anchorOffset: 0,
                                    focusKey: 'eqe3p',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '182p5': {
                                        key: '182p5',
                                        type: 'unstyled',
                                        text: 'Artists',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '3kn5l': {
                                        key: '3kn5l',
                                        type: 'unstyled',
                                        text: 'Rick Rothenberg',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '3kn5l',
                                    anchorOffset: 0,
                                    focusKey: '3kn5l',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: '3kn5l',
                                    anchorOffset: 15,
                                    focusKey: '3kn5l',
                                    focusOffset: 15,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '182p5': {
                                        key: '182p5',
                                        type: 'unstyled',
                                        text: 'Artists',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '3kn5l': {
                                        key: '3kn5l',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '182p5',
                                    anchorOffset: 7,
                                    focusKey: '182p5',
                                    focusOffset: 7,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: '3kn5l',
                                    anchorOffset: 0,
                                    focusKey: '3kn5l',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '182p5': {
                                        key: '182p5',
                                        type: 'unstyled',
                                        text: 'Artists',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '182p5',
                                    anchorOffset: 0,
                                    focusKey: '182p5',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: '182p5',
                                    anchorOffset: 7,
                                    focusKey: '182p5',
                                    focusOffset: 7,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '182p5': {
                                        key: '182p5',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '182p5',
                                    anchorOffset: 1,
                                    focusKey: '182p5',
                                    focusOffset: 1,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: '182p5',
                                    anchorOffset: 0,
                                    focusKey: '182p5',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '182p5': {
                                        key: '182p5',
                                        type: 'unstyled',
                                        text: 'a',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '182p5',
                                    anchorOffset: 0,
                                    focusKey: '182p5',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: '182p5',
                                    anchorOffset: 1,
                                    focusKey: '182p5',
                                    focusOffset: 1,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '182p5': {
                                        key: '182p5',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '182p5',
                                    anchorOffset: 0,
                                    focusKey: '182p5',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: '182p5',
                                    anchorOffset: 0,
                                    focusKey: '182p5',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '182p5': {
                                        key: '182p5',
                                        type: 'unstyled',
                                        text: 'r',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '182p5',
                                    anchorOffset: 2,
                                    focusKey: '182p5',
                                    focusOffset: 2,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '182p5',
                                    anchorOffset: 1,
                                    focusKey: '182p5',
                                    focusOffset: 1,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '182p5': {
                                        key: '182p5',
                                        type: 'unstyled',
                                        text: 'rA',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '182p5',
                                    anchorOffset: 2,
                                    focusKey: '182p5',
                                    focusOffset: 2,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '182p5',
                                    anchorOffset: 2,
                                    focusKey: '182p5',
                                    focusOffset: 2,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '182p5': {
                                        key: '182p5',
                                        type: 'unstyled',
                                        text: 'Ar',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '182p5',
                                    anchorOffset: 0,
                                    focusKey: '182p5',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '182p5',
                                    anchorOffset: 2,
                                    focusKey: '182p5',
                                    focusOffset: 2,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '182p5': {
                                        key: '182p5',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '182p5',
                                    anchorOffset: 0,
                                    focusKey: '182p5',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '182p5',
                                    anchorOffset: 0,
                                    focusKey: '182p5',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '182p5': {
                                        key: '182p5',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '182p5',
                                    anchorOffset: 0,
                                    focusKey: '182p5',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '182p5',
                                    anchorOffset: 0,
                                    focusKey: '182p5',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                        ],
                    },
                },
                textColor: '#003747',
                textOpacity: 100,
                textAlign: 'right',
                fontSize: '2.2rem',
                lineHeight: '17px',
                fontFamily: 'MONTSERRAT',
                isFocus: false,
            },
        },
        {
            box: {
                x: 6,
                y: 36,
                w: 3,
                h: 4,
                i: '55681a95-2e3c-4fe9-8bc2-72052b9615d0',
                static: false,
                type: 'textBox',
            },
            style: {
                content: 'ABOUT US',
                editorState: {
                    _immutable: {
                        allowUndo: true,
                        currentContent: {
                            entityMap: {},
                            blockMap: {
                                '62ofr': {
                                    key: '62ofr',
                                    type: 'unstyled',
                                    text: 'ABOUT US',
                                    characterList: [
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                    ],
                                    depth: 0,
                                    data: {},
                                },
                            },
                            selectionBefore: {
                                anchorKey: '62ofr',
                                anchorOffset: 0,
                                focusKey: '62ofr',
                                focusOffset: 8,
                                isBackward: false,
                                hasFocus: false,
                            },
                            selectionAfter: {
                                anchorKey: '62ofr',
                                anchorOffset: 0,
                                focusKey: '62ofr',
                                focusOffset: 8,
                                isBackward: false,
                                hasFocus: false,
                            },
                        },
                        decorator: null,
                        directionMap: {
                            '62ofr': 'LTR',
                        },
                        forceSelection: false,
                        inCompositionMode: false,
                        inlineStyleOverride: null,
                        lastChangeType: 'change-inline-style',
                        nativelyRenderedContent: null,
                        redoStack: [],
                        selection: {
                            anchorKey: '62ofr',
                            anchorOffset: 5,
                            focusKey: '62ofr',
                            focusOffset: 5,
                            isBackward: false,
                            hasFocus: false,
                        },
                        treeMap: {
                            '62ofr': [
                                {
                                    start: 0,
                                    end: 8,
                                    decoratorKey: null,
                                    leaves: [
                                        {
                                            start: 0,
                                            end: 8,
                                        },
                                    ],
                                },
                            ],
                        },
                        undoStack: [
                            {
                                entityMap: {},
                                blockMap: {
                                    '62ofr': {
                                        key: '62ofr',
                                        type: 'unstyled',
                                        text: 'ABOUT US',
                                        characterList: [
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '62ofr',
                                    anchorOffset: 0,
                                    focusKey: '62ofr',
                                    focusOffset: 8,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '62ofr',
                                    anchorOffset: 0,
                                    focusKey: '62ofr',
                                    focusOffset: 8,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '62ofr': {
                                        key: '62ofr',
                                        type: 'unstyled',
                                        text: 'ABOUT US',
                                        characterList: [
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '62ofr',
                                    anchorOffset: 0,
                                    focusKey: '62ofr',
                                    focusOffset: 8,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '62ofr',
                                    anchorOffset: 0,
                                    focusKey: '62ofr',
                                    focusOffset: 8,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '62ofr': {
                                        key: '62ofr',
                                        type: 'unstyled',
                                        text: 'ABOUT US',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '62ofr',
                                    anchorOffset: 0,
                                    focusKey: '62ofr',
                                    focusOffset: 8,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '62ofr',
                                    anchorOffset: 0,
                                    focusKey: '62ofr',
                                    focusOffset: 8,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '62ofr': {
                                        key: '62ofr',
                                        type: 'unstyled',
                                        text: 'ABOUT US',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '62ofr',
                                    anchorOffset: 1,
                                    focusKey: '62ofr',
                                    focusOffset: 1,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: '62ofr',
                                    anchorOffset: 8,
                                    focusKey: '62ofr',
                                    focusOffset: 8,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '62ofr': {
                                        key: '62ofr',
                                        type: 'unstyled',
                                        text: 'A',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '62ofr',
                                    anchorOffset: 0,
                                    focusKey: '62ofr',
                                    focusOffset: 4,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '62ofr',
                                    anchorOffset: 1,
                                    focusKey: '62ofr',
                                    focusOffset: 1,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '62ofr': {
                                        key: '62ofr',
                                        type: 'unstyled',
                                        text: 'BOUA',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '62ofr',
                                    anchorOffset: 1,
                                    focusKey: '62ofr',
                                    focusOffset: 1,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '62ofr',
                                    anchorOffset: 3,
                                    focusKey: '62ofr',
                                    focusOffset: 3,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '62ofr': {
                                        key: '62ofr',
                                        type: 'unstyled',
                                        text: 'BA',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '62ofr',
                                    anchorOffset: 2,
                                    focusKey: '62ofr',
                                    focusOffset: 2,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '62ofr',
                                    anchorOffset: 2,
                                    focusKey: '62ofr',
                                    focusOffset: 2,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '62ofr': {
                                        key: '62ofr',
                                        type: 'unstyled',
                                        text: 'AB',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '62ofr',
                                    anchorOffset: 0,
                                    focusKey: '62ofr',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '62ofr',
                                    anchorOffset: 2,
                                    focusKey: '62ofr',
                                    focusOffset: 2,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '62ofr': {
                                        key: '62ofr',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '62ofr',
                                    anchorOffset: 0,
                                    focusKey: '62ofr',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '62ofr',
                                    anchorOffset: 0,
                                    focusKey: '62ofr',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '62ofr': {
                                        key: '62ofr',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '62ofr',
                                    anchorOffset: 0,
                                    focusKey: '62ofr',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '62ofr',
                                    anchorOffset: 0,
                                    focusKey: '62ofr',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                        ],
                    },
                },
                textColor: '#003747',
                textOpacity: 100,
                textAlign: 'left',
                fontSize: '6.5rem',
                lineHeight: '6.5rem',
                fontFamily: 'BROWN_SUGAR',
                isFocus: false,
            },
        },
        {
            box: {
                x: 1,
                y: 44,
                w: 4,
                h: 3,
                i: '530272c2-0b10-4fa9-85a0-2e839641e6a2',
                static: false,
                type: 'textBox',
            },
            style: {
                content:
                    'I am fascinated by the idea of using simple math to create complex art. My work takes simple geometric shapes and adjusts them using combinations of common functions that you might encounter in a high school math course.',
                editorState: {
                    _immutable: {
                        allowUndo: true,
                        currentContent: {
                            entityMap: {},
                            blockMap: {
                                dfub4: {
                                    key: 'dfub4',
                                    type: 'unstyled',
                                    text: 'I am fascinated by the idea of using simple math to create complex art. My work takes simple geometric shapes and adjusts them using combinations of common functions that you might encounter in a high school math course.',
                                    characterList: [
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['MONTSERRAT', 'CONTENT'],
                                            entity: null,
                                        },
                                    ],
                                    depth: 0,
                                    data: {},
                                },
                            },
                            selectionBefore: {
                                anchorKey: 'dfub4',
                                anchorOffset: 0,
                                focusKey: 'dfub4',
                                focusOffset: 220,
                                isBackward: false,
                                hasFocus: false,
                            },
                            selectionAfter: {
                                anchorKey: 'dfub4',
                                anchorOffset: 0,
                                focusKey: 'dfub4',
                                focusOffset: 220,
                                isBackward: false,
                                hasFocus: false,
                            },
                        },
                        decorator: null,
                        directionMap: {
                            dfub4: 'LTR',
                        },
                        forceSelection: false,
                        inCompositionMode: false,
                        inlineStyleOverride: null,
                        lastChangeType: 'change-inline-style',
                        nativelyRenderedContent: null,
                        redoStack: [],
                        selection: {
                            anchorKey: 'dfub4',
                            anchorOffset: 0,
                            focusKey: 'dfub4',
                            focusOffset: 220,
                            isBackward: false,
                            hasFocus: false,
                        },
                        treeMap: {
                            dfub4: [
                                {
                                    start: 0,
                                    end: 220,
                                    decoratorKey: null,
                                    leaves: [
                                        {
                                            start: 0,
                                            end: 220,
                                        },
                                    ],
                                },
                            ],
                        },
                        undoStack: [
                            {
                                entityMap: {},
                                blockMap: {
                                    dfub4: {
                                        key: 'dfub4',
                                        type: 'unstyled',
                                        text: 'I am fascinated by the idea of using simple math to create complex art. My work takes simple geometric shapes and adjusts them using combinations of common functions that you might encounter in a high school math course.',
                                        characterList: [
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'dfub4',
                                    anchorOffset: 0,
                                    focusKey: 'dfub4',
                                    focusOffset: 220,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'dfub4',
                                    anchorOffset: 0,
                                    focusKey: 'dfub4',
                                    focusOffset: 220,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    dfub4: {
                                        key: 'dfub4',
                                        type: 'unstyled',
                                        text: 'I am fascinated by the idea of using simple math to create complex art. My work takes simple geometric shapes and adjusts them using combinations of common functions that you might encounter in a high school math course.',
                                        characterList: [
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['MONTSERRAT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'dfub4',
                                    anchorOffset: 0,
                                    focusKey: 'dfub4',
                                    focusOffset: 220,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'dfub4',
                                    anchorOffset: 0,
                                    focusKey: 'dfub4',
                                    focusOffset: 220,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    dfub4: {
                                        key: 'dfub4',
                                        type: 'unstyled',
                                        text: 'I am fascinated by the idea of using simple math to create complex art. My work takes simple geometric shapes and adjusts them using combinations of common functions that you might encounter in a high school math course.',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'dfub4',
                                    anchorOffset: 0,
                                    focusKey: 'dfub4',
                                    focusOffset: 220,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'dfub4',
                                    anchorOffset: 0,
                                    focusKey: 'dfub4',
                                    focusOffset: 220,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    dfub4: {
                                        key: 'dfub4',
                                        type: 'unstyled',
                                        text: 'I am fascinated by the idea of using simple math to create complex art. My work takes simple geometric shapes and adjusts them using combinations of common functions that you might encounter in a high school math course.',
                                        characterList: [
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['BROWN_SUGAR'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'dfub4',
                                    anchorOffset: 0,
                                    focusKey: 'dfub4',
                                    focusOffset: 220,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'dfub4',
                                    anchorOffset: 0,
                                    focusKey: 'dfub4',
                                    focusOffset: 220,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    dfub4: {
                                        key: 'dfub4',
                                        type: 'unstyled',
                                        text: 'I am fascinated by the idea of using simple math to create complex art. My work takes simple geometric shapes and adjusts them using combinations of common functions that you might encounter in a high school math course.',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'dfub4',
                                    anchorOffset: 0,
                                    focusKey: 'dfub4',
                                    focusOffset: 220,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'dfub4',
                                    anchorOffset: 0,
                                    focusKey: 'dfub4',
                                    focusOffset: 220,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    dfub4: {
                                        key: 'dfub4',
                                        type: 'unstyled',
                                        text: 'I am fascinated by the idea of using simple math to create complex art. My work takes simple geometric shapes and adjusts them using combinations of common functions that you might encounter in a high school math course.',
                                        characterList: [
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                            {
                                                style: [],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'dfub4',
                                    anchorOffset: 0,
                                    focusKey: 'dfub4',
                                    focusOffset: 1,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'dfub4',
                                    anchorOffset: 220,
                                    focusKey: 'dfub4',
                                    focusOffset: 220,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    dfub4: {
                                        key: 'dfub4',
                                        type: 'unstyled',
                                        text: 'A',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'dfub4',
                                    anchorOffset: 0,
                                    focusKey: 'dfub4',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'dfub4',
                                    anchorOffset: 1,
                                    focusKey: 'dfub4',
                                    focusOffset: 1,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    dfub4: {
                                        key: 'dfub4',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'dfub4',
                                    anchorOffset: 0,
                                    focusKey: 'dfub4',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'dfub4',
                                    anchorOffset: 0,
                                    focusKey: 'dfub4',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    dfub4: {
                                        key: 'dfub4',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'dfub4',
                                    anchorOffset: 0,
                                    focusKey: 'dfub4',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'dfub4',
                                    anchorOffset: 0,
                                    focusKey: 'dfub4',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                        ],
                    },
                },
                textColor: '#003747',
                textOpacity: 100,
                textAlign: 'left',
                fontSize: '1.4rem',
                lineHeight: '14px',
                fontFamily: 'MONTSERRAT',
                isFocus: false,
            },
        },
        {
            box: {
                x: 3,
                y: 67,
                w: 6,
                h: 4,
                i: '1440c8c9-314e-4730-987a-d4d9163a4a22',
                static: false,
                type: 'textBox',
            },
            style: {
                content: 'PREVIOUS WORKS',
                editorState: {
                    _immutable: {
                        allowUndo: true,
                        currentContent: {
                            entityMap: {},
                            blockMap: {
                                '1a6r0': {
                                    key: '1a6r0',
                                    type: 'unstyled',
                                    text: 'PREVIOUS WORKS',
                                    characterList: [
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                    ],
                                    depth: 0,
                                    data: {},
                                },
                            },
                            selectionBefore: {
                                anchorKey: '1a6r0',
                                anchorOffset: 0,
                                focusKey: '1a6r0',
                                focusOffset: 14,
                                isBackward: false,
                                hasFocus: false,
                            },
                            selectionAfter: {
                                anchorKey: '1a6r0',
                                anchorOffset: 0,
                                focusKey: '1a6r0',
                                focusOffset: 14,
                                isBackward: false,
                                hasFocus: false,
                            },
                        },
                        decorator: null,
                        directionMap: {
                            '1a6r0': 'LTR',
                        },
                        forceSelection: false,
                        inCompositionMode: false,
                        inlineStyleOverride: null,
                        lastChangeType: 'change-inline-style',
                        nativelyRenderedContent: null,
                        redoStack: [],
                        selection: {
                            anchorKey: '1a6r0',
                            anchorOffset: 0,
                            focusKey: '1a6r0',
                            focusOffset: 14,
                            isBackward: false,
                            hasFocus: false,
                        },
                        treeMap: {
                            '1a6r0': [
                                {
                                    start: 0,
                                    end: 14,
                                    decoratorKey: null,
                                    leaves: [
                                        {
                                            start: 0,
                                            end: 14,
                                        },
                                    ],
                                },
                            ],
                        },
                        undoStack: [
                            {
                                entityMap: {},
                                blockMap: {
                                    '1a6r0': {
                                        key: '1a6r0',
                                        type: 'unstyled',
                                        text: 'PREVIOUS WORKS',
                                        characterList: [
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '1a6r0',
                                    anchorOffset: 0,
                                    focusKey: '1a6r0',
                                    focusOffset: 14,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '1a6r0',
                                    anchorOffset: 0,
                                    focusKey: '1a6r0',
                                    focusOffset: 14,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '1a6r0': {
                                        key: '1a6r0',
                                        type: 'unstyled',
                                        text: 'PREVIOUS WORKS',
                                        characterList: [
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '1a6r0',
                                    anchorOffset: 0,
                                    focusKey: '1a6r0',
                                    focusOffset: 14,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '1a6r0',
                                    anchorOffset: 0,
                                    focusKey: '1a6r0',
                                    focusOffset: 14,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '1a6r0': {
                                        key: '1a6r0',
                                        type: 'unstyled',
                                        text: 'PREVIOUS WORKS',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '1a6r0',
                                    anchorOffset: 0,
                                    focusKey: '1a6r0',
                                    focusOffset: 14,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '1a6r0',
                                    anchorOffset: 0,
                                    focusKey: '1a6r0',
                                    focusOffset: 14,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '1a6r0': {
                                        key: '1a6r0',
                                        type: 'unstyled',
                                        text: 'PREVIOUS WORKS',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '1a6r0',
                                    anchorOffset: 0,
                                    focusKey: '1a6r0',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '1a6r0',
                                    anchorOffset: 14,
                                    focusKey: '1a6r0',
                                    focusOffset: 14,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '1a6r0': {
                                        key: '1a6r0',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '1a6r0',
                                    anchorOffset: 0,
                                    focusKey: '1a6r0',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '1a6r0',
                                    anchorOffset: 0,
                                    focusKey: '1a6r0',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '1a6r0': {
                                        key: '1a6r0',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '1a6r0',
                                    anchorOffset: 0,
                                    focusKey: '1a6r0',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '1a6r0',
                                    anchorOffset: 0,
                                    focusKey: '1a6r0',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                        ],
                    },
                },
                textColor: '#003747',
                textOpacity: 100,
                textAlign: 'center',
                fontSize: '6.5rem',
                lineHeight: '6.5rem',
                fontFamily: 'BROWN_SUGAR',
                isFocus: false,
            },
        },
        {
            box: {
                x: 8,
                y: 189,
                w: 3,
                h: 5,
                i: 'dbe7aa7e-8400-4fad-90b1-7ecfd46a81cb',
                static: false,
                type: 'textBox',
            },
            style: {
                content:
                    'via email\nc.rickrothenberg@outlook.com\nc.planetvolumes@outlook.com\nc.concateam@outlook.com\n\nvia phone\n+84 901975772',
                editorState: {
                    _immutable: {
                        allowUndo: true,
                        currentContent: {
                            entityMap: {},
                            blockMap: {
                                '2r9kb': {
                                    key: '2r9kb',
                                    type: 'unstyled',
                                    text: 'via email',
                                    characterList: [
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                    ],
                                    depth: 0,
                                    data: {},
                                },
                                '439us': {
                                    key: '439us',
                                    type: 'unstyled',
                                    text: 'c.rickrothenberg@outlook.com',
                                    characterList: [
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                    ],
                                    depth: 0,
                                    data: {},
                                },
                                bg0pq: {
                                    key: 'bg0pq',
                                    type: 'unstyled',
                                    text: 'c.planetvolumes@outlook.com',
                                    characterList: [
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                    ],
                                    depth: 0,
                                    data: {},
                                },
                                fs53c: {
                                    key: 'fs53c',
                                    type: 'unstyled',
                                    text: 'c.concateam@outlook.com',
                                    characterList: [
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                    ],
                                    depth: 0,
                                    data: {},
                                },
                                '958h9': {
                                    key: '958h9',
                                    type: 'unstyled',
                                    text: '',
                                    characterList: [],
                                    depth: 0,
                                    data: {},
                                },
                                '7rqk8': {
                                    key: '7rqk8',
                                    type: 'unstyled',
                                    text: 'via phone',
                                    characterList: [
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                    ],
                                    depth: 0,
                                    data: {},
                                },
                                '95v0e': {
                                    key: '95v0e',
                                    type: 'unstyled',
                                    text: '+84 901975772',
                                    characterList: [
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                    ],
                                    depth: 0,
                                    data: {},
                                },
                            },
                            selectionBefore: {
                                anchorKey: '2r9kb',
                                anchorOffset: 0,
                                focusKey: '95v0e',
                                focusOffset: 13,
                                isBackward: false,
                                hasFocus: false,
                            },
                            selectionAfter: {
                                anchorKey: '2r9kb',
                                anchorOffset: 0,
                                focusKey: '95v0e',
                                focusOffset: 13,
                                isBackward: false,
                                hasFocus: false,
                            },
                        },
                        decorator: null,
                        directionMap: {
                            '2r9kb': 'LTR',
                            '439us': 'LTR',
                            bg0pq: 'LTR',
                            fs53c: 'LTR',
                            '958h9': 'LTR',
                            '7rqk8': 'LTR',
                            '95v0e': 'LTR',
                        },
                        forceSelection: false,
                        inCompositionMode: false,
                        inlineStyleOverride: null,
                        lastChangeType: 'change-inline-style',
                        nativelyRenderedContent: null,
                        redoStack: [],
                        selection: {
                            anchorKey: '2r9kb',
                            anchorOffset: 0,
                            focusKey: '95v0e',
                            focusOffset: 13,
                            isBackward: false,
                            hasFocus: false,
                        },
                        treeMap: {
                            '2r9kb': [
                                {
                                    start: 0,
                                    end: 9,
                                    decoratorKey: null,
                                    leaves: [
                                        {
                                            start: 0,
                                            end: 9,
                                        },
                                    ],
                                },
                            ],
                            '439us': [
                                {
                                    start: 0,
                                    end: 28,
                                    decoratorKey: null,
                                    leaves: [
                                        {
                                            start: 0,
                                            end: 28,
                                        },
                                    ],
                                },
                            ],
                            bg0pq: [
                                {
                                    start: 0,
                                    end: 27,
                                    decoratorKey: null,
                                    leaves: [
                                        {
                                            start: 0,
                                            end: 27,
                                        },
                                    ],
                                },
                            ],
                            fs53c: [
                                {
                                    start: 0,
                                    end: 23,
                                    decoratorKey: null,
                                    leaves: [
                                        {
                                            start: 0,
                                            end: 23,
                                        },
                                    ],
                                },
                            ],
                            '958h9': [
                                {
                                    start: 0,
                                    end: 0,
                                    decoratorKey: null,
                                    leaves: [
                                        {
                                            start: 0,
                                            end: 0,
                                        },
                                    ],
                                },
                            ],
                            '7rqk8': [
                                {
                                    start: 0,
                                    end: 9,
                                    decoratorKey: null,
                                    leaves: [
                                        {
                                            start: 0,
                                            end: 9,
                                        },
                                    ],
                                },
                            ],
                            '95v0e': [
                                {
                                    start: 0,
                                    end: 13,
                                    decoratorKey: null,
                                    leaves: [
                                        {
                                            start: 0,
                                            end: 13,
                                        },
                                    ],
                                },
                            ],
                        },
                        undoStack: [
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '439us': {
                                        key: '439us',
                                        type: 'unstyled',
                                        text: 'c.rickrothenberg@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    bg0pq: {
                                        key: 'bg0pq',
                                        type: 'unstyled',
                                        text: 'c.planetvolumes@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    fs53c: {
                                        key: 'fs53c',
                                        type: 'unstyled',
                                        text: 'c.concateam@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '958h9': {
                                        key: '958h9',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                    '7rqk8': {
                                        key: '7rqk8',
                                        type: 'unstyled',
                                        text: 'via phone',
                                        characterList: [
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '95v0e': {
                                        key: '95v0e',
                                        type: 'unstyled',
                                        text: '+84 901975772',
                                        characterList: [
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '2r9kb',
                                    anchorOffset: 0,
                                    focusKey: '95v0e',
                                    focusOffset: 13,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '2r9kb',
                                    anchorOffset: 0,
                                    focusKey: '95v0e',
                                    focusOffset: 13,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '439us': {
                                        key: '439us',
                                        type: 'unstyled',
                                        text: 'c.rickrothenberg@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    bg0pq: {
                                        key: 'bg0pq',
                                        type: 'unstyled',
                                        text: 'c.planetvolumes@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    fs53c: {
                                        key: 'fs53c',
                                        type: 'unstyled',
                                        text: 'c.concateam@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '958h9': {
                                        key: '958h9',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                    '7rqk8': {
                                        key: '7rqk8',
                                        type: 'unstyled',
                                        text: 'via phone',
                                        characterList: [
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '95v0e': {
                                        key: '95v0e',
                                        type: 'unstyled',
                                        text: '+84 901975772',
                                        characterList: [
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '2r9kb',
                                    anchorOffset: 0,
                                    focusKey: '95v0e',
                                    focusOffset: 13,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '2r9kb',
                                    anchorOffset: 0,
                                    focusKey: '95v0e',
                                    focusOffset: 13,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '439us': {
                                        key: '439us',
                                        type: 'unstyled',
                                        text: 'c.rickrothenberg@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    bg0pq: {
                                        key: 'bg0pq',
                                        type: 'unstyled',
                                        text: 'c.planetvolumes@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    fs53c: {
                                        key: 'fs53c',
                                        type: 'unstyled',
                                        text: 'c.concateam@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '958h9': {
                                        key: '958h9',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                    '7rqk8': {
                                        key: '7rqk8',
                                        type: 'unstyled',
                                        text: 'via phone',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '95v0e': {
                                        key: '95v0e',
                                        type: 'unstyled',
                                        text: '+84 901975772',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '2r9kb',
                                    anchorOffset: 0,
                                    focusKey: '95v0e',
                                    focusOffset: 13,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '2r9kb',
                                    anchorOffset: 0,
                                    focusKey: '95v0e',
                                    focusOffset: 13,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '439us': {
                                        key: '439us',
                                        type: 'unstyled',
                                        text: 'c.rickrothenberg@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    bg0pq: {
                                        key: 'bg0pq',
                                        type: 'unstyled',
                                        text: 'c.planetvolumes@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    fs53c: {
                                        key: 'fs53c',
                                        type: 'unstyled',
                                        text: 'c.concateam@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '958h9': {
                                        key: '958h9',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                    '7rqk8': {
                                        key: '7rqk8',
                                        type: 'unstyled',
                                        text: 'via phone',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '95v0e': {
                                        key: '95v0e',
                                        type: 'unstyled',
                                        text: '+84 901975772',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '95v0e',
                                    anchorOffset: 2,
                                    focusKey: '95v0e',
                                    focusOffset: 2,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: '95v0e',
                                    anchorOffset: 13,
                                    focusKey: '95v0e',
                                    focusOffset: 13,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '439us': {
                                        key: '439us',
                                        type: 'unstyled',
                                        text: 'c.rickrothenberg@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    bg0pq: {
                                        key: 'bg0pq',
                                        type: 'unstyled',
                                        text: 'c.planetvolumes@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    fs53c: {
                                        key: 'fs53c',
                                        type: 'unstyled',
                                        text: 'c.concateam@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '958h9': {
                                        key: '958h9',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                    '7rqk8': {
                                        key: '7rqk8',
                                        type: 'unstyled',
                                        text: 'via phone',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '95v0e': {
                                        key: '95v0e',
                                        type: 'unstyled',
                                        text: '+8',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '95v0e',
                                    anchorOffset: 3,
                                    focusKey: '95v0e',
                                    focusOffset: 3,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: '95v0e',
                                    anchorOffset: 2,
                                    focusKey: '95v0e',
                                    focusOffset: 2,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '439us': {
                                        key: '439us',
                                        type: 'unstyled',
                                        text: 'c.rickrothenberg@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    bg0pq: {
                                        key: 'bg0pq',
                                        type: 'unstyled',
                                        text: 'c.planetvolumes@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    fs53c: {
                                        key: 'fs53c',
                                        type: 'unstyled',
                                        text: 'c.concateam@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '958h9': {
                                        key: '958h9',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                    '7rqk8': {
                                        key: '7rqk8',
                                        type: 'unstyled',
                                        text: 'via phone',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '95v0e': {
                                        key: '95v0e',
                                        type: 'unstyled',
                                        text: '+85',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '95v0e',
                                    anchorOffset: 0,
                                    focusKey: '95v0e',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: '95v0e',
                                    anchorOffset: 3,
                                    focusKey: '95v0e',
                                    focusOffset: 3,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '439us': {
                                        key: '439us',
                                        type: 'unstyled',
                                        text: 'c.rickrothenberg@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    bg0pq: {
                                        key: 'bg0pq',
                                        type: 'unstyled',
                                        text: 'c.planetvolumes@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    fs53c: {
                                        key: 'fs53c',
                                        type: 'unstyled',
                                        text: 'c.concateam@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '958h9': {
                                        key: '958h9',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                    '7rqk8': {
                                        key: '7rqk8',
                                        type: 'unstyled',
                                        text: 'via phone',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '95v0e': {
                                        key: '95v0e',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '7rqk8',
                                    anchorOffset: 9,
                                    focusKey: '7rqk8',
                                    focusOffset: 9,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: '95v0e',
                                    anchorOffset: 0,
                                    focusKey: '95v0e',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '439us': {
                                        key: '439us',
                                        type: 'unstyled',
                                        text: 'c.rickrothenberg@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    bg0pq: {
                                        key: 'bg0pq',
                                        type: 'unstyled',
                                        text: 'c.planetvolumes@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    fs53c: {
                                        key: 'fs53c',
                                        type: 'unstyled',
                                        text: 'c.concateam@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '958h9': {
                                        key: '958h9',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                    '7rqk8': {
                                        key: '7rqk8',
                                        type: 'unstyled',
                                        text: 'via phone',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '7rqk8',
                                    anchorOffset: 4,
                                    focusKey: '7rqk8',
                                    focusOffset: 4,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: '7rqk8',
                                    anchorOffset: 9,
                                    focusKey: '7rqk8',
                                    focusOffset: 9,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '439us': {
                                        key: '439us',
                                        type: 'unstyled',
                                        text: 'c.rickrothenberg@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    bg0pq: {
                                        key: 'bg0pq',
                                        type: 'unstyled',
                                        text: 'c.planetvolumes@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    fs53c: {
                                        key: 'fs53c',
                                        type: 'unstyled',
                                        text: 'c.concateam@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '958h9': {
                                        key: '958h9',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                    '7rqk8': {
                                        key: '7rqk8',
                                        type: 'unstyled',
                                        text: 'via ',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '7rqk8',
                                    anchorOffset: 6,
                                    focusKey: '7rqk8',
                                    focusOffset: 6,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: '7rqk8',
                                    anchorOffset: 4,
                                    focusKey: '7rqk8',
                                    focusOffset: 4,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '439us': {
                                        key: '439us',
                                        type: 'unstyled',
                                        text: 'c.rickrothenberg@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    bg0pq: {
                                        key: 'bg0pq',
                                        type: 'unstyled',
                                        text: 'c.planetvolumes@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    fs53c: {
                                        key: 'fs53c',
                                        type: 'unstyled',
                                        text: 'c.concateam@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '958h9': {
                                        key: '958h9',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                    '7rqk8': {
                                        key: '7rqk8',
                                        type: 'unstyled',
                                        text: 'via oh',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '7rqk8',
                                    anchorOffset: 0,
                                    focusKey: '7rqk8',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: '7rqk8',
                                    anchorOffset: 6,
                                    focusKey: '7rqk8',
                                    focusOffset: 6,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '439us': {
                                        key: '439us',
                                        type: 'unstyled',
                                        text: 'c.rickrothenberg@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    bg0pq: {
                                        key: 'bg0pq',
                                        type: 'unstyled',
                                        text: 'c.planetvolumes@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    fs53c: {
                                        key: 'fs53c',
                                        type: 'unstyled',
                                        text: 'c.concateam@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '958h9': {
                                        key: '958h9',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                    '7rqk8': {
                                        key: '7rqk8',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '958h9',
                                    anchorOffset: 0,
                                    focusKey: '958h9',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: '7rqk8',
                                    anchorOffset: 0,
                                    focusKey: '7rqk8',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '439us': {
                                        key: '439us',
                                        type: 'unstyled',
                                        text: 'c.rickrothenberg@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    bg0pq: {
                                        key: 'bg0pq',
                                        type: 'unstyled',
                                        text: 'c.planetvolumes@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    fs53c: {
                                        key: 'fs53c',
                                        type: 'unstyled',
                                        text: 'c.concateam@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '958h9': {
                                        key: '958h9',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'fs53c',
                                    anchorOffset: 23,
                                    focusKey: 'fs53c',
                                    focusOffset: 23,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: '958h9',
                                    anchorOffset: 0,
                                    focusKey: '958h9',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '439us': {
                                        key: '439us',
                                        type: 'unstyled',
                                        text: 'c.rickrothenberg@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    bg0pq: {
                                        key: 'bg0pq',
                                        type: 'unstyled',
                                        text: 'c.planetvolumes@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    fs53c: {
                                        key: 'fs53c',
                                        type: 'unstyled',
                                        text: 'c.concateam@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'fs53c',
                                    anchorOffset: 0,
                                    focusKey: 'fs53c',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: 'fs53c',
                                    anchorOffset: 23,
                                    focusKey: 'fs53c',
                                    focusOffset: 23,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '439us': {
                                        key: '439us',
                                        type: 'unstyled',
                                        text: 'c.rickrothenberg@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    bg0pq: {
                                        key: 'bg0pq',
                                        type: 'unstyled',
                                        text: 'c.planetvolumes@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    fs53c: {
                                        key: 'fs53c',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'bg0pq',
                                    anchorOffset: 27,
                                    focusKey: 'bg0pq',
                                    focusOffset: 27,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: 'fs53c',
                                    anchorOffset: 0,
                                    focusKey: 'fs53c',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '439us': {
                                        key: '439us',
                                        type: 'unstyled',
                                        text: 'c.rickrothenberg@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    bg0pq: {
                                        key: 'bg0pq',
                                        type: 'unstyled',
                                        text: 'c.planetvolumes@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'bg0pq',
                                    anchorOffset: 9,
                                    focusKey: 'bg0pq',
                                    focusOffset: 9,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: 'bg0pq',
                                    anchorOffset: 27,
                                    focusKey: 'bg0pq',
                                    focusOffset: 27,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '439us': {
                                        key: '439us',
                                        type: 'unstyled',
                                        text: 'c.rickrothenberg@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    bg0pq: {
                                        key: 'bg0pq',
                                        type: 'unstyled',
                                        text: 'c.planetv',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'bg0pq',
                                    anchorOffset: 13,
                                    focusKey: 'bg0pq',
                                    focusOffset: 13,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: 'bg0pq',
                                    anchorOffset: 9,
                                    focusKey: 'bg0pq',
                                    focusOffset: 9,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '439us': {
                                        key: '439us',
                                        type: 'unstyled',
                                        text: 'c.rickrothenberg@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    bg0pq: {
                                        key: 'bg0pq',
                                        type: 'unstyled',
                                        text: 'c.planetvlume',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'bg0pq',
                                    anchorOffset: 3,
                                    focusKey: 'bg0pq',
                                    focusOffset: 3,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: 'bg0pq',
                                    anchorOffset: 13,
                                    focusKey: 'bg0pq',
                                    focusOffset: 13,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '439us': {
                                        key: '439us',
                                        type: 'unstyled',
                                        text: 'c.rickrothenberg@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    bg0pq: {
                                        key: 'bg0pq',
                                        type: 'unstyled',
                                        text: 'c.p',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'bg0pq',
                                    anchorOffset: 4,
                                    focusKey: 'bg0pq',
                                    focusOffset: 4,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: 'bg0pq',
                                    anchorOffset: 3,
                                    focusKey: 'bg0pq',
                                    focusOffset: 3,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '439us': {
                                        key: '439us',
                                        type: 'unstyled',
                                        text: 'c.rickrothenberg@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    bg0pq: {
                                        key: 'bg0pq',
                                        type: 'unstyled',
                                        text: 'c.pa',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'bg0pq',
                                    anchorOffset: 0,
                                    focusKey: 'bg0pq',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: 'bg0pq',
                                    anchorOffset: 4,
                                    focusKey: 'bg0pq',
                                    focusOffset: 4,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '439us': {
                                        key: '439us',
                                        type: 'unstyled',
                                        text: 'c.rickrothenberg@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    bg0pq: {
                                        key: 'bg0pq',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '439us',
                                    anchorOffset: 28,
                                    focusKey: '439us',
                                    focusOffset: 28,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: 'bg0pq',
                                    anchorOffset: 0,
                                    focusKey: 'bg0pq',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '439us': {
                                        key: '439us',
                                        type: 'unstyled',
                                        text: 'c.rickrothenberg@outlook.com',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '439us',
                                    anchorOffset: 0,
                                    focusKey: '439us',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: '439us',
                                    anchorOffset: 28,
                                    focusKey: '439us',
                                    focusOffset: 28,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                    '439us': {
                                        key: '439us',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '2r9kb',
                                    anchorOffset: 9,
                                    focusKey: '2r9kb',
                                    focusOffset: 9,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: '439us',
                                    anchorOffset: 0,
                                    focusKey: '439us',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'via email',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '2r9kb',
                                    anchorOffset: 1,
                                    focusKey: '2r9kb',
                                    focusOffset: 1,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: '2r9kb',
                                    anchorOffset: 9,
                                    focusKey: '2r9kb',
                                    focusOffset: 9,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'v',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '2r9kb',
                                    anchorOffset: 0,
                                    focusKey: '2r9kb',
                                    focusOffset: 3,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '2r9kb',
                                    anchorOffset: 1,
                                    focusKey: '2r9kb',
                                    focusOffset: 1,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'iav',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '2r9kb',
                                    anchorOffset: 1,
                                    focusKey: '2r9kb',
                                    focusOffset: 1,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '2r9kb',
                                    anchorOffset: 2,
                                    focusKey: '2r9kb',
                                    focusOffset: 2,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'iv',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '2r9kb',
                                    anchorOffset: 2,
                                    focusKey: '2r9kb',
                                    focusOffset: 2,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '2r9kb',
                                    anchorOffset: 2,
                                    focusKey: '2r9kb',
                                    focusOffset: 2,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: 'vi',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '2r9kb',
                                    anchorOffset: 0,
                                    focusKey: '2r9kb',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '2r9kb',
                                    anchorOffset: 2,
                                    focusKey: '2r9kb',
                                    focusOffset: 2,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '2r9kb',
                                    anchorOffset: 0,
                                    focusKey: '2r9kb',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '2r9kb',
                                    anchorOffset: 0,
                                    focusKey: '2r9kb',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '2r9kb': {
                                        key: '2r9kb',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '2r9kb',
                                    anchorOffset: 0,
                                    focusKey: '2r9kb',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '2r9kb',
                                    anchorOffset: 0,
                                    focusKey: '2r9kb',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                        ],
                    },
                },
                textColor: '#003747',
                textOpacity: 100,
                textAlign: 'right',
                fontSize: '2.2rem',
                lineHeight: '17px',
                fontFamily: 'MONTSERRAT',
                isFocus: false,
            },
        },
        {
            box: {
                x: 7,
                y: 180,
                w: 4,
                h: 2,
                i: '0d77c468-63f6-4572-a731-c2b76bde1d05',
                static: false,
                type: 'textBox',
            },
            style: {
                content: 'CONTACT US',
                editorState: {
                    _immutable: {
                        allowUndo: true,
                        currentContent: {
                            entityMap: {},
                            blockMap: {
                                d1vo2: {
                                    key: 'd1vo2',
                                    type: 'unstyled',
                                    text: 'CONTACT US',
                                    characterList: [
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'BROWN_SUGAR', 'TITLE'],
                                            entity: null,
                                        },
                                    ],
                                    depth: 0,
                                    data: {},
                                },
                            },
                            selectionBefore: {
                                anchorKey: 'd1vo2',
                                anchorOffset: 0,
                                focusKey: 'd1vo2',
                                focusOffset: 10,
                                isBackward: false,
                                hasFocus: false,
                            },
                            selectionAfter: {
                                anchorKey: 'd1vo2',
                                anchorOffset: 0,
                                focusKey: 'd1vo2',
                                focusOffset: 10,
                                isBackward: false,
                                hasFocus: false,
                            },
                        },
                        decorator: null,
                        directionMap: {
                            d1vo2: 'LTR',
                        },
                        forceSelection: false,
                        inCompositionMode: false,
                        inlineStyleOverride: null,
                        lastChangeType: 'change-inline-style',
                        nativelyRenderedContent: null,
                        redoStack: [],
                        selection: {
                            anchorKey: 'd1vo2',
                            anchorOffset: 0,
                            focusKey: 'd1vo2',
                            focusOffset: 10,
                            isBackward: false,
                            hasFocus: false,
                        },
                        treeMap: {
                            d1vo2: [
                                {
                                    start: 0,
                                    end: 10,
                                    decoratorKey: null,
                                    leaves: [
                                        {
                                            start: 0,
                                            end: 10,
                                        },
                                    ],
                                },
                            ],
                        },
                        undoStack: [
                            {
                                entityMap: {},
                                blockMap: {
                                    d1vo2: {
                                        key: 'd1vo2',
                                        type: 'unstyled',
                                        text: 'CONTACT US',
                                        characterList: [
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'd1vo2',
                                    anchorOffset: 0,
                                    focusKey: 'd1vo2',
                                    focusOffset: 10,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'd1vo2',
                                    anchorOffset: 0,
                                    focusKey: 'd1vo2',
                                    focusOffset: 10,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    d1vo2: {
                                        key: 'd1vo2',
                                        type: 'unstyled',
                                        text: 'CONTACT US',
                                        characterList: [
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'BROWN_SUGAR'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'd1vo2',
                                    anchorOffset: 0,
                                    focusKey: 'd1vo2',
                                    focusOffset: 10,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'd1vo2',
                                    anchorOffset: 0,
                                    focusKey: 'd1vo2',
                                    focusOffset: 10,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    d1vo2: {
                                        key: 'd1vo2',
                                        type: 'unstyled',
                                        text: 'CONTACT US',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'd1vo2',
                                    anchorOffset: 0,
                                    focusKey: 'd1vo2',
                                    focusOffset: 10,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'd1vo2',
                                    anchorOffset: 0,
                                    focusKey: 'd1vo2',
                                    focusOffset: 10,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    d1vo2: {
                                        key: 'd1vo2',
                                        type: 'unstyled',
                                        text: 'CONTACT US',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'd1vo2',
                                    anchorOffset: 0,
                                    focusKey: 'd1vo2',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'd1vo2',
                                    anchorOffset: 10,
                                    focusKey: 'd1vo2',
                                    focusOffset: 10,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    d1vo2: {
                                        key: 'd1vo2',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'd1vo2',
                                    anchorOffset: 0,
                                    focusKey: 'd1vo2',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'd1vo2',
                                    anchorOffset: 0,
                                    focusKey: 'd1vo2',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    d1vo2: {
                                        key: 'd1vo2',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'd1vo2',
                                    anchorOffset: 0,
                                    focusKey: 'd1vo2',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'd1vo2',
                                    anchorOffset: 0,
                                    focusKey: 'd1vo2',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                        ],
                    },
                },
                textColor: '#003747',
                textOpacity: 100,
                textAlign: 'left',
                fontSize: '6.5rem',
                lineHeight: '6.5rem',
                fontFamily: 'BROWN_SUGAR',
                isFocus: false,
            },
        },
        {
            box: {
                x: 1,
                y: 153,
                w: 3,
                h: 2,
                i: 'b063958b-9001-41c7-9946-7f867b207b44',
                static: false,
                type: 'textBox',
            },
            style: {
                content: '3D Renders using Math',
                editorState: {
                    _immutable: {
                        allowUndo: true,
                        currentContent: {
                            entityMap: {},
                            blockMap: {
                                d0snq: {
                                    key: 'd0snq',
                                    type: 'unstyled',
                                    text: '3D Renders using Math',
                                    characterList: [
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT', 'SUB_HEADING'],
                                            entity: null,
                                        },
                                    ],
                                    depth: 0,
                                    data: {},
                                },
                            },
                            selectionBefore: {
                                anchorKey: 'd0snq',
                                anchorOffset: 0,
                                focusKey: 'd0snq',
                                focusOffset: 21,
                                isBackward: false,
                                hasFocus: false,
                            },
                            selectionAfter: {
                                anchorKey: 'd0snq',
                                anchorOffset: 0,
                                focusKey: 'd0snq',
                                focusOffset: 21,
                                isBackward: false,
                                hasFocus: false,
                            },
                        },
                        decorator: null,
                        directionMap: {
                            d0snq: 'LTR',
                        },
                        forceSelection: false,
                        inCompositionMode: false,
                        inlineStyleOverride: null,
                        lastChangeType: 'change-inline-style',
                        nativelyRenderedContent: null,
                        redoStack: [],
                        selection: {
                            anchorKey: 'd0snq',
                            anchorOffset: 0,
                            focusKey: 'd0snq',
                            focusOffset: 21,
                            isBackward: false,
                            hasFocus: false,
                        },
                        treeMap: {
                            d0snq: [
                                {
                                    start: 0,
                                    end: 21,
                                    decoratorKey: null,
                                    leaves: [
                                        {
                                            start: 0,
                                            end: 21,
                                        },
                                    ],
                                },
                            ],
                        },
                        undoStack: [
                            {
                                entityMap: {},
                                blockMap: {
                                    d0snq: {
                                        key: 'd0snq',
                                        type: 'unstyled',
                                        text: '3D Renders using Math',
                                        characterList: [
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT', 'MONTSERRAT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 0,
                                    focusKey: 'd0snq',
                                    focusOffset: 21,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 0,
                                    focusKey: 'd0snq',
                                    focusOffset: 21,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    d0snq: {
                                        key: 'd0snq',
                                        type: 'unstyled',
                                        text: '3D Renders using Math',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 0,
                                    focusKey: 'd0snq',
                                    focusOffset: 21,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 0,
                                    focusKey: 'd0snq',
                                    focusOffset: 21,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    d0snq: {
                                        key: 'd0snq',
                                        type: 'unstyled',
                                        text: '3D Renders using Math',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 5,
                                    focusKey: 'd0snq',
                                    focusOffset: 5,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 21,
                                    focusKey: 'd0snq',
                                    focusOffset: 21,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    d0snq: {
                                        key: 'd0snq',
                                        type: 'unstyled',
                                        text: '3D Re',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 7,
                                    focusKey: 'd0snq',
                                    focusOffset: 7,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 5,
                                    focusKey: 'd0snq',
                                    focusOffset: 5,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    d0snq: {
                                        key: 'd0snq',
                                        type: 'unstyled',
                                        text: '3D Remd',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 3,
                                    focusKey: 'd0snq',
                                    focusOffset: 3,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 7,
                                    focusKey: 'd0snq',
                                    focusOffset: 7,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    d0snq: {
                                        key: 'd0snq',
                                        type: 'unstyled',
                                        text: '3D ',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 4,
                                    focusKey: 'd0snq',
                                    focusOffset: 4,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 3,
                                    focusKey: 'd0snq',
                                    focusOffset: 3,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    d0snq: {
                                        key: 'd0snq',
                                        type: 'unstyled',
                                        text: '3D r',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 1,
                                    focusKey: 'd0snq',
                                    focusOffset: 1,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 0,
                                    focusKey: 'd0snq',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    d0snq: {
                                        key: 'd0snq',
                                        type: 'unstyled',
                                        text: 'R3D r',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 0,
                                    focusKey: 'd0snq',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                                selectionAfter: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 1,
                                    focusKey: 'd0snq',
                                    focusOffset: 1,
                                    isBackward: false,
                                    hasFocus: true,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    d0snq: {
                                        key: 'd0snq',
                                        type: 'unstyled',
                                        text: '3D r',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 5,
                                    focusKey: 'd0snq',
                                    focusOffset: 5,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 4,
                                    focusKey: 'd0snq',
                                    focusOffset: 4,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    d0snq: {
                                        key: 'd0snq',
                                        type: 'unstyled',
                                        text: '3D re',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 0,
                                    focusKey: 'd0snq',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 5,
                                    focusKey: 'd0snq',
                                    focusOffset: 5,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    d0snq: {
                                        key: 'd0snq',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 0,
                                    focusKey: 'd0snq',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 0,
                                    focusKey: 'd0snq',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    d0snq: {
                                        key: 'd0snq',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 0,
                                    focusKey: 'd0snq',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: 'd0snq',
                                    anchorOffset: 0,
                                    focusKey: 'd0snq',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                        ],
                    },
                },
                textColor: '#003747',
                textOpacity: 100,
                textAlign: 'center',
                fontSize: '2.2rem',
                lineHeight: '17px',
                fontFamily: 'MONTSERRAT',
                isFocus: false,
            },
        },
        {
            box: {
                x: 0,
                y: 205,
                w: 2,
                h: 2,
                i: 'f88e2e61-6f40-4d29-b47a-8d4ae5e63222',
                static: false,
                type: 'textBox',
            },
            style: {
                content: 'VOTE FOR CON CA TEAM',
                editorState: {
                    _immutable: {
                        allowUndo: true,
                        currentContent: {
                            entityMap: {},
                            blockMap: {
                                '9lmhg': {
                                    key: '9lmhg',
                                    type: 'unstyled',
                                    text: 'VOTE FOR CON CA TEAM',
                                    characterList: [
                                        {
                                            style: ['INHERIT', 'MONTSERRAT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT'],
                                            entity: null,
                                        },
                                        {
                                            style: ['INHERIT', 'MONTSERRAT'],
                                            entity: null,
                                        },
                                    ],
                                    depth: 0,
                                    data: {},
                                },
                            },
                            selectionBefore: {
                                anchorKey: '9lmhg',
                                anchorOffset: 0,
                                focusKey: '9lmhg',
                                focusOffset: 20,
                                isBackward: false,
                                hasFocus: false,
                            },
                            selectionAfter: {
                                anchorKey: '9lmhg',
                                anchorOffset: 0,
                                focusKey: '9lmhg',
                                focusOffset: 20,
                                isBackward: false,
                                hasFocus: false,
                            },
                        },
                        decorator: null,
                        directionMap: {
                            '9lmhg': 'LTR',
                        },
                        forceSelection: false,
                        inCompositionMode: false,
                        inlineStyleOverride: null,
                        lastChangeType: 'change-inline-style',
                        nativelyRenderedContent: null,
                        redoStack: [],
                        selection: {
                            anchorKey: '9lmhg',
                            anchorOffset: 10,
                            focusKey: '9lmhg',
                            focusOffset: 10,
                            isBackward: false,
                            hasFocus: false,
                        },
                        treeMap: {
                            '9lmhg': [
                                {
                                    start: 0,
                                    end: 20,
                                    decoratorKey: null,
                                    leaves: [
                                        {
                                            start: 0,
                                            end: 20,
                                        },
                                    ],
                                },
                            ],
                        },
                        undoStack: [
                            {
                                entityMap: {},
                                blockMap: {
                                    '9lmhg': {
                                        key: '9lmhg',
                                        type: 'unstyled',
                                        text: 'VOTE FOR CON CA TEAM',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '9lmhg',
                                    anchorOffset: 0,
                                    focusKey: '9lmhg',
                                    focusOffset: 20,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '9lmhg',
                                    anchorOffset: 0,
                                    focusKey: '9lmhg',
                                    focusOffset: 20,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '9lmhg': {
                                        key: '9lmhg',
                                        type: 'unstyled',
                                        text: 'VOTE FOR CON CA TEAM',
                                        characterList: [
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                            {
                                                style: ['INHERIT'],
                                                entity: null,
                                            },
                                        ],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '9lmhg',
                                    anchorOffset: 0,
                                    focusKey: '9lmhg',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '9lmhg',
                                    anchorOffset: 20,
                                    focusKey: '9lmhg',
                                    focusOffset: 20,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '9lmhg': {
                                        key: '9lmhg',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '9lmhg',
                                    anchorOffset: 0,
                                    focusKey: '9lmhg',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '9lmhg',
                                    anchorOffset: 0,
                                    focusKey: '9lmhg',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                            {
                                entityMap: {},
                                blockMap: {
                                    '9lmhg': {
                                        key: '9lmhg',
                                        type: 'unstyled',
                                        text: '',
                                        characterList: [],
                                        depth: 0,
                                        data: {},
                                    },
                                },
                                selectionBefore: {
                                    anchorKey: '9lmhg',
                                    anchorOffset: 0,
                                    focusKey: '9lmhg',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                                selectionAfter: {
                                    anchorKey: '9lmhg',
                                    anchorOffset: 0,
                                    focusKey: '9lmhg',
                                    focusOffset: 0,
                                    isBackward: false,
                                    hasFocus: false,
                                },
                            },
                        ],
                    },
                },
                textColor: '#1c1c1c',
                textOpacity: 100,
                textAlign: 'left',
                fontSize: '',
                lineHeight: '',
                fontFamily: 'MONTSERRAT',
                isFocus: false,
            },
        },
        {
            box: {
                x: 0,
                y: 4,
                w: 7,
                h: 25,
                i: 'a87e9aed-49f2-454d-aff1-12e09fd612b9',
                static: false,
                type: 'imageBox',
            },
            style: {
                croppedImageUrl: 'https://i.ibb.co/SyPggfs/5b7cb2a1f301.png',
                selectFile: {
                    file: [],
                    isHavingFile: false,
                },
                imageOpacity: 100,
                isFocus: false,
            },
        },
        {
            box: {
                x: 6,
                y: 40,
                w: 6,
                h: 19,
                i: '7131d83f-c08c-4dce-97fe-9d9442770077',
                static: false,
                type: 'imageBox',
            },
            style: {
                croppedImageUrl: 'https://i.ibb.co/WGs3S5p/4bcb55797aa6.png',
                selectFile: {
                    file: [],
                    isHavingFile: false,
                },
                imageOpacity: 100,
                isFocus: false,
            },
        },
        {
            box: {
                x: 6,
                y: 73,
                w: 5,
                h: 26,
                i: '70293c48-f28f-411f-94b9-1450bf2e7436',
                static: false,
                type: 'imageBox',
            },
            style: {
                croppedImageUrl: 'https://i.ibb.co/GpwB312/8f63322a2f08.png',
                selectFile: {
                    file: [],
                    isHavingFile: false,
                },
                imageOpacity: 100,
                isFocus: false,
            },
        },
        {
            box: {
                x: 1,
                y: 75,
                w: 5,
                h: 26,
                i: '475d4aee-a9c1-499e-9bc2-79393923a453',
                static: false,
                type: 'imageBox',
            },
            style: {
                croppedImageUrl: 'https://i.ibb.co/j5m3c0b/eaaea941345a.png',
                selectFile: {
                    file: [],
                    isHavingFile: false,
                },
                imageOpacity: 100,
                isFocus: false,
            },
        },
        {
            box: {
                x: 5,
                y: 146,
                w: 7,
                h: 24,
                i: 'ab4d0431-ef39-4af8-abb8-20ce9ae03142',
                static: false,
                type: 'imageBox',
            },
            style: {
                croppedImageUrl: 'https://i.ibb.co/fd2bzTq/49b6424dbada.png',
                selectFile: {
                    file: [],
                    isHavingFile: false,
                },
                imageOpacity: 100,
                isFocus: false,
            },
        },
        {
            box: {
                x: 10,
                y: 17,
                w: 1,
                h: 3,
                i: 'd5515fd6-b25c-4f05-a869-da1bf48f9751',
                static: false,
                type: 'btnBox',
            },
            style: {
                btnName: 'Explore',
                btnLink: 'https://unsplash.com/@rick_rothenberg',
                bgColor: '#003747',
                borderColor: '',
                textColor: '',
                variant: 'solid',
                btnOpacity: 100,
                isFocus: false,
                isOpenModal: false,
            },
        },
        {
            box: {
                x: 8,
                y: 83,
                w: 2,
                h: 6,
                i: '1872c12e-5fcb-4516-b157-8bdb74d74d5c',
                static: false,
                type: 'imageBox',
            },
            style: {
                croppedImageUrl: 'https://i.ibb.co/Lvv58bP/aef7f63d4467.png',
                selectFile: {
                    file: [],
                    isHavingFile: false,
                },
                imageOpacity: 100,
                isFocus: false,
            },
        },
        {
            box: {
                x: 0,
                y: 109,
                w: 12,
                h: 31,
                i: '32864141-1bd4-48bf-bb09-4fdb4aabe9d1',
                static: false,
                type: 'imageBox',
            },
            style: {
                croppedImageUrl: 'https://i.ibb.co/gdtwf9t/232e50e05b47.png',
                selectFile: {
                    file: [],
                    isHavingFile: false,
                },
                imageOpacity: 100,
                isFocus: false,
            },
        },
    ],
}
